/*
 * KL perf 08.10.2026 (etap 2): lzejsze filtry kolekcji i wyszukiwarki.
 *
 * 1) Jedna lista filtrow. Motyw Vessel renderowal te sama liste 2x (kolumna boczna na komputerze + szuflada
 *    na telefonie), co dawalo ok. 1,2 MB HTML. Teraz Liquid renderuje liste tylko w kolumnie bocznej
 *    ([data-kl-kolumna]); szuflada mobile ma pusty kontener ([data-kl-szuflada]). Przy otwarciu szuflady
 *    przenosimy elementy listy do szuflady, przy zamknieciu oddajemy je kolumnie.
 * 2) Leniwe wartosci. Wartosci listy ponad pierwsze 10 (nieaktywne) leza w <script type="application/json"
 *    data-kl-reszta> i sa budowane dopiero po "Pokaz wiecej" (show-more.js wola window.klFacety.zbuduj).
 * 3) Hook "kl:przed-morph" (section-renderer.js): po zmianie filtra motyw pobiera sekcje przez Section
 *    Rendering API i robi morph. Zanim morph ruszy, w NOWYM drzewie odtwarzamy to, co w starym zrobil JS
 *    (lista w otwartej szufladzie, dobudowane wartosci) - inaczej morph wyczyscilby szuflade i rozwiniecia.
 */
(() => {
  if (window.klFacety) return;

  const KOL = '[data-kl-kolumna]';
  const SZU = '[data-kl-szuflada]';
  const OTWIERACZ = '[on\\:click="#filters-drawer/showDialog"]';
  const SVG_CHECK =
    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" class="icon-checkmark" aria-hidden="true"><use href="#kl-i-check"></use></svg>';
  const SVG_DIS =
    '<svg aria-hidden="true" width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none"><line x1="100" y1="0" x2="0" y2="100" vector-effect="non-scaling-stroke" /></svg>';

  const esc = (s) =>
    String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);

  /** HTML jednej wartosci - ten sam znacznik co w snippets/list-filter.liquid */
  function liHtml(d, w, ukryte) {
    const [i, val, lab, dis] = w;
    const id = d.pre + i + d.suf;
    const cls = 'facets__inputs-list-item' + (ukryte ? ' ' + d.hc : '');
    const wspolne = `name="${esc(d.n)}" value="${esc(val)}" id="${esc(id)}"`;
    const inner = d.pill
      ? `<div class="facets__pill-wrapper" on:keydown="#facet-inputs-component-${esc(d.pid)}/handleKeyDown"><input type="checkbox" ${wspolne} class="facets__pill-input" data-label="${esc(lab)}"${dis ? ' disabled' : ''} ref="facetInputs[]" tabindex="-1"><label class="facets__pill-label" for="${esc(id)}" tabindex="0">${esc(lab)}${dis ? SVG_DIS : ''}</label></div>`
      : `<div class="checkbox" on:pointerenter="/prefetchPage" on:pointerleave="/cancelPrefetchPage"><input type="checkbox" ${wspolne} class="checkbox__input" data-label="${esc(lab)}"${dis ? ' disabled' : ''} ref="facetInputs[]"><label class="checkbox__label" for="${esc(id)}" role="checkbox">${SVG_CHECK}<span class="checkbox__label-text">${esc(lab)}</span></label></div>`;
    return `<li data-skip-node-update="true" class="${cls}" ref="showMoreItems[]" data-kl-i="${i}">${inner}</li>`;
  }

  /**
   * Dobudowuje leniwe wartosci w danym show-more-component (zywy DOM albo nowe drzewo przed morph).
   * @param {Element} sm - show-more-component
   * @param {boolean} [ukryte] - czy nowe pozycje maja klase hidden (domyslnie tak, show-more je odslania)
   * @returns {boolean} czy cos dobudowano
   */
  function zbuduj(sm, ukryte = true) {
    if (!sm || sm.hasAttribute('data-kl-zbudowane')) return false;
    const s = sm.querySelector('script[data-kl-reszta]');
    const ul = sm.querySelector('.facets__inputs-list');
    if (!s || !ul) return false;
    let d;
    try {
      d = JSON.parse(s.textContent || '{}');
    } catch (e) {
      return false;
    }
    if (!Array.isArray(d.w) || !d.w.length) return false;
    const doc = ul.ownerDocument;
    const tpl = doc.createElement('template');
    tpl.innerHTML = d.w.map((w) => liHtml(d, w, ukryte)).join('');
    // kolejnosc jak w Shopify: aktywne wartosci ponad limit sa juz w DOM (data-kl-i), wstawiamy wg indeksu
    const wszystkie = [...ul.querySelectorAll(':scope > li[data-kl-i]'), ...tpl.content.querySelectorAll('li')];
    wszystkie.sort((a, b) => Number(a.dataset.klI) - Number(b.dataset.klI));
    for (const li of wszystkie) ul.appendChild(li);
    sm.setAttribute('data-kl-zbudowane', '');
    // refs komponentu z inputami odswiezamy od razu (obserwator Component dziala dopiero po requestIdleCallback)
    const fic = sm.closest('facet-inputs-component');
    if (fic && doc === document && typeof fic.updatedCallback === 'function') {
      try {
        fic.updatedCallback();
      } catch (e) {}
    }
    return true;
  }

  /** Przenosi elementy listy filtrow miedzy kolumna a szuflada w danym korzeniu (document albo nowe drzewo). */
  function przenies(root, doSzuflady) {
    const kol = root.querySelector(KOL);
    const szu = root.querySelector(SZU);
    if (!kol || !szu) return false;
    const [z, na] = doSzuflady ? [kol, szu] : [szu, kol];
    if (!z.firstChild) return false;
    while (z.firstChild) na.appendChild(z.firstChild);
    return true;
  }

  function doSzuflady() {
    if (!przenies(document, true)) return;
    const szu = document.querySelector(SZU);
    // jak w Vessel: fokus po otwarciu na pierwszym polu pierwszego filtra, o ile ten filtr nie ma aktywnych wartosci
    const pierwszy = szu.querySelector('.facets__item');
    const aktywne =
      !pierwszy ||
      pierwszy.querySelector('input[type="checkbox"]:checked') ||
      [...pierwszy.querySelectorAll('.price-facet__input')].some((i) => i.value !== '');
    if (!aktywne) {
      const pierwsze = szu.querySelector('input:not([type="hidden"]):not([disabled]):not([data-kv2-sz-in])'); // runda 9: nie pole szukania opcji (klawiatura na telefonie)
      if (pierwsze) pierwsze.setAttribute('autofocus', '');
      szu.dataset.klAutofocus = '';
    }
  }

  function doKolumny() {
    const szu = document.querySelector(SZU);
    if (szu && 'klAutofocus' in szu.dataset) {
      szu.querySelectorAll('[autofocus]').forEach((el) => el.removeAttribute('autofocus'));
      delete szu.dataset.klAutofocus;
    }
    przenies(document, false);
  }

  const szufladaOtwarta = (root) => !!root.querySelector('#filters-drawer dialog[open]');

  // otwarcie: klik w "Filtry" (motyw otwiera dialog dopiero w requestAnimationFrame, wiec zdazymy przed showModal)
  document.addEventListener(
    'click',
    (e) => {
      const t = e.target instanceof Element ? e.target.closest(OTWIERACZ) : null;
      if (t) doSzuflady();
    },
    true
  );
  // zamkniecie: natywne zdarzenie close na <dialog> (nie bubbluje, wiec capture)
  document.addEventListener(
    'close',
    (e) => {
      if (e.target instanceof Element && e.target.closest('#filters-drawer')) doKolumny();
    },
    true
  );

  // zabezpieczenie: dialog otwarty inna droga (albo skrypt zaladowal sie po otwarciu)
  function pilnuj() {
    const dlg = document.querySelector('#filters-drawer dialog');
    if (!dlg || dlg.__klPilnuj) return;
    dlg.__klPilnuj = true;
    new MutationObserver(() => {
      const szu = document.querySelector(SZU);
      if (dlg.open && szu && !szu.firstElementChild) doSzuflady();
    }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    if (dlg.open) doSzuflady();
  }

  document.addEventListener('kl:przed-morph', (e) => {
    const { stary, nowy } = e.detail || {};
    if (!stary || !nowy || !nowy.querySelector(KOL)) return;
    // 1) rozwiniete wczesniej filtry: dobuduj wartosci takze w nowym drzewie (stan rozwiniecia ze starego)
    stary.querySelectorAll('show-more-component[data-kl-zbudowane]').forEach((sm) => {
      const pn = sm.closest('[data-filter-param-name]')?.getAttribute('data-filter-param-name');
      if (!pn) return;
      const nsm = nowy.querySelector(`[data-filter-param-name="${CSS.escape(pn)}"] show-more-component`);
      if (nsm) zbuduj(nsm, sm.getAttribute('data-expanded') !== 'true');
    });
    // 2) lista tam, gdzie jest teraz w zywym DOM (otwarta szuflada albo kolumna)
    przenies(nowy, szufladaOtwarta(stary));
    // morph podmieni szuflade w miejscu, wiec autofocus (tylko przy otwieraniu) nie jest potrzebny
  });

  window.klFacety = { zbuduj, doSzuflady, doKolumny };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pilnuj);
  else pilnuj();
  // po przerysowaniu sekcji dialog moze byc nowym elementem
  document.addEventListener('kl:przed-morph', () => queueMicrotask(pilnuj));
})();
